import { useState } from "react";
import { TicketPercent } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { logError } from "../../lib/log";

export const OrderSummary = ({ items, isB2B, promo, setPromo, total, discountAmount, grandTotal, missing, minOrder }) => {
  const [promoInput, setPromoInput] = useState("");

  const applyPromo = async () => {
    const code = promoInput.trim().toUpperCase();
    if (!code) return;
    try {
      const r = await api.get("/newsletter/validate", { params: { code } });
      if (r.data.valid) {
        setPromo({ code, percent: r.data.discount_percent });
        toast.success(`Codice applicato: -${r.data.discount_percent}%`);
      } else {
        setPromo(null);
        toast.error("Codice sconto non valido o già utilizzato");
      }
    } catch (e) {
      logError("Promo validation failed:", e);
      toast.error("Errore nella verifica del codice");
    }
  };

  return (
    <div className="rounded-2xl border border-[#E7E0D8] bg-white p-6 sticky top-28">
      <h2 className="font-serif-display font-bold text-xl mb-5">Riepilogo ordine</h2>
      <div className="space-y-4 max-h-80 overflow-y-auto pr-1">
        {items.map((i) => (
          <div key={i.slug} className="flex items-center gap-3">
            <img src={i.image} alt={i.name} className="w-12 h-12 rounded-lg object-cover border border-[#E7E0D8]" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium truncate">{i.name}</p>
              <p className="font-mono-accent text-xs text-[#78716C]">× {i.quantity}</p>
            </div>
            <span className="font-mono-accent text-sm">{(i.price * i.quantity).toFixed(2).replace(".", ",")} €</span>
          </div>
        ))}
      </div>
      {!isB2B && (
        <div className="border-t border-[#E7E0D8] mt-5 pt-5">
          <label className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#78716C] mb-2 flex items-center gap-1.5">
            <TicketPercent className="w-3.5 h-3.5" /> Codice sconto
          </label>
          {promo ? (
            <div data-testid="promo-applied" className="flex items-center justify-between rounded-xl bg-[#7DC242]/15 px-4 py-3">
              <span className="font-mono-accent text-sm font-semibold text-[#2E8A57]">{promo.code} · -{promo.percent}%</span>
              <button data-testid="promo-remove-btn" type="button" onClick={() => setPromo(null)} className="text-xs text-[#78716C] hover:text-[#2E8A57] underline">Rimuovi</button>
            </div>
          ) : (
            <div className="flex gap-2">
              <input
                data-testid="promo-code-input"
                value={promoInput}
                onChange={(e) => setPromoInput(e.target.value)}
                placeholder="ES. GF10-XXXXXX"
                className="flex-1 min-w-0 rounded-xl border border-[#E7E0D8] bg-white px-4 py-3 text-sm uppercase focus:outline-none focus:border-[#2E8A57] transition-colors"
              />
              <button data-testid="promo-apply-btn" type="button" onClick={applyPromo} className="px-5 rounded-xl border border-[#1C1917] text-sm font-semibold hover:bg-[#1C1917] hover:text-[#FDFBF7] transition-colors">
                Applica
              </button>
            </div>
          )}
        </div>
      )}
      <div className="border-t border-[#E7E0D8] mt-5 pt-5 space-y-2">
        {promo && (
          <>
            <div className="flex justify-between items-baseline text-sm text-[#78716C]">
              <span>Subtotale</span>
              <span className="font-mono-accent">{total.toFixed(2).replace(".", ",")} €</span>
            </div>
            <div data-testid="checkout-discount-row" className="flex justify-between items-baseline text-sm text-[#2E8A57] font-semibold">
              <span>Sconto {promo.code}</span>
              <span className="font-mono-accent">-{discountAmount.toFixed(2).replace(".", ",")} €</span>
            </div>
          </>
        )}
        <div className="flex justify-between items-baseline">
          <span className="text-sm text-[#78716C]">Totale</span>
          <span data-testid="checkout-total" className="font-serif-display font-bold text-2xl">{grandTotal.toFixed(2).replace(".", ",")} €</span>
        </div>
      </div>
      {missing > 0 && (
        <p data-testid="checkout-min-order-warning" className="mt-3 text-xs text-[#2E8A57] font-semibold">Ordine minimo {minOrder.toFixed(0)}€ — mancano {missing.toFixed(2).replace(".", ",")} €</p>
      )}
    </div>
  );
};
